<template>
  <d-card class="card-small mb-3 h-100 mx-0">
    <!-- Card Header -->
    <d-card-header class="border-bottom mb-1">
      <h6 class="m-0">
        Message Box
        <d-input-group class="mt-2">
          <d-input placeholder="Search name, company, or title">
            <d-input-group-addon append></d-input-group-addon>
            <i class="material-icons">search</i>
          </d-input>
        </d-input-group>
      </h6>
    </d-card-header>

    <d-card-body class="p-0 div-scroll">
      <d-list-group flush>
        <!-- Categories -->
        <d-row>
          <d-col>
            <d-list-group class="border-bottom">
              <d-list-group-item>
                <img
                  class="social-avatar rounded-circle mr-2"
                  src="@/assets/images/avatars/2.jpg"
                  alt
                >
                <span>Marky Mark</span>
              </d-list-group-item>
              <d-list-group-item>
                <img
                  class="social-avatar rounded-circle mr-2"
                  src="@/assets/images/avatars/2.jpg"
                  alt
                >
                <span>Marky Mark</span>
              </d-list-group-item>
              <d-list-group-item>
                <img
                  class="social-avatar rounded-circle mr-2"
                  src="@/assets/images/avatars/2.jpg"
                  alt
                >
                <span>Marky Mark</span>
              </d-list-group-item>
              <d-list-group-item>
                <img
                  class="social-avatar rounded-circle mr-2"
                  src="@/assets/images/avatars/2.jpg"
                  alt
                >
                <span>Marky Mark</span>
              </d-list-group-item>
              <d-list-group-item>
                <img
                  class="social-avatar rounded-circle mr-2"
                  src="@/assets/images/avatars/2.jpg"
                  alt
                >
                <span>Marky Mark</span>
              </d-list-group-item>
              <d-list-group-item>
                <img
                  class="social-avatar rounded-circle mr-2"
                  src="@/assets/images/avatars/2.jpg"
                  alt
                >
                <span>Marky Mark</span>
              </d-list-group-item>
            </d-list-group>
          </d-col>
        </d-row>
      </d-list-group>
    </d-card-body>
  </d-card>
</template>

<script>
export default {
  name: "messages-box",
  props: {
    /**
     * The component's title.
     */
  },
  data() {
    return {
      messages: [
        {
          name: "Marky Mark",
          profileImg: "@/assets/images/avatars/2.jpg",
          platform: "Facebook"
        }
      ]
    };
  }
};
</script>

